import { useEffect, useMemo, useState } from "react";
import "./RegisterFormAdvertiser.css";

export default function RegisterFormAdvertiser({
  id = "register",
  eyebrow = "REGISTER",
  title = "Already Registered?",
  loginLabel = "Log in",
  submitLabel = "Submit",
  fields = {},
  onSubmit,
  onLogin,
  className = "",
  style = {},
}) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    let cancelled = false;
    async function loadCountries() {
      try {
        const res = await fetch("https://restcountries.com/v3.1/all?fields=name");
        if (!res.ok) throw new Error("Failed to fetch countries");
        const data = await res.json();
        if (!cancelled && Array.isArray(data)) {
          const list = data
            .map(item => item?.name?.common)
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b));
          setCountries(list);
        }
      } catch {
        if (!cancelled) setCountries(["United States", "United Kingdom", "Germany", "France", "Bulgaria"]);
      }
    }
    loadCountries();
    return () => { cancelled = true; };
  }, []);

  const [values, setValues] = useState({
    company: "",
    contactPerson: "",
    email: "",
    country: "",
    message: "",
  });

  const getField = (key, fallbackLabel, fallbackPlaceholder) => ({
    label: fields[key]?.label || fallbackLabel,
    placeholder: fields[key]?.placeholder || fallbackPlaceholder,
  });

  const company = getField("company", "Company", "Company name");
  const contactPerson = getField("contactPerson", "Contact person", "Contact");
  const email = getField("email", "Email", "E-mail");
  const country = getField("country", "Country", "Select country");
  const messageField = {
    label: fields.message?.label || "Message",
    helper: fields.message?.helper || "",
    placeholder: fields.message?.placeholder || "Type here",
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setValues(prev => ({ ...prev, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit?.(values);
  }

  return (
    <section id={id} className={`reg-adv-section ${className}`.trim()} style={style}>
      <div className="reg-adv-wrap">


        <div className="reg-adv-card">
          <header className="reg-adv-head">
            <p className="reg-adv-eyebrow">{eyebrow}</p>
            <h2 className="reg-adv-title">{title}</h2>
            <button type="button" className="reg-adv-login" onClick={onLogin}>
              <span>{loginLabel.toUpperCase()}</span>
            </button>
          </header>
          <span className="reg-adv-dot reg-adv-dot--tl" aria-hidden="true" />
          <span className="reg-adv-dot reg-adv-dot--tr" aria-hidden="true" />
          <span className="reg-adv-dot reg-adv-dot--bl" aria-hidden="true" />
          <span className="reg-adv-dot reg-adv-dot--br" aria-hidden="true" />
          <span className="reg-adv-dot reg-adv-dot--mid" aria-hidden="true" />

          <form className="reg-adv-form" onSubmit={handleSubmit}>
            <div className="reg-adv-row">
              <label className="reg-adv-field">
                <span className="reg-adv-label">{company.label}</span>
                <input
                  type="text"
                  name="company"
                  placeholder={company.placeholder}
                  value={values.company}
                  onChange={handleChange}
                  required
                />
              </label>
              <label className="reg-adv-field">
                <span className="reg-adv-label">{contactPerson.label}</span>
                <input
                  type="text"
                  name="contactPerson"
                  placeholder={contactPerson.placeholder}
                  value={values.contactPerson}
                  onChange={handleChange}
                  required
                />
              </label>
            </div>

            <div className="reg-adv-row">
              <label className="reg-adv-field">
                <span className="reg-adv-label">{email.label}</span>
                <input
                  type="email"
                  name="email"
                  placeholder={email.placeholder}
                  value={values.email}
                  onChange={handleChange}
                  required
                />
              </label>
              <label className="reg-adv-field">
                <span className="reg-adv-label">{country.label}</span>
                <div className="reg-adv-select">
                  <select name="country" value={values.country} onChange={handleChange} required>
                    <option value="" disabled>{country.placeholder}</option>
                    {countries.map(name => (
                      <option key={name} value={name}>{name}</option>
                    ))}
                  </select>
                </div>
              </label>
            </div>

            <label className="reg-adv-field">
              <span className="reg-adv-label">
                {messageField.label}
                {messageField.helper && <small>{messageField.helper}</small>}
              </span>
              <textarea
                name="message"
                placeholder={messageField.placeholder}
                rows={6}
                value={values.message}
                onChange={handleChange}
              />
            </label>

            <div className="reg-adv-actions">
              <button type="submit" className="reg-adv-submit">
                <span>{submitLabel.toUpperCase()}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
